export const complaint_list = [
    'store', 'cust_phone', 'operator', 'resolved_at', 'resolved_emp', 'resolved_note', 'category', 'cust_complaint', 'updated_at', 'created_at'
]